import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import getEntities from '../services/entities';

export default function Select({ path, name, onChangeFcn, visible, label, data }) {
    const[options, setOptions] = useState([])

    useEffect(function(){
        getEntities(path, data).then(opts => {
          opts.unshift({ id: '0', nombre: 'Selecciona un ' + name})
          setOptions(opts)
        })
    }, [data])

    let visiblityClass = '';
    if(!visible) visiblityClass += ' hide';
    
    return (
        <div className='horizontal-content'>
            <label className={ `col-form-label${visiblityClass}` } htmlFor={`select-${name}`}>{ label }</label>
            <select className={ `form-control${visiblityClass} ` } id={`select-${name}`} onChange={onChangeFcn}>
                {
                    options.map(opt => <option key={name + opt.id} value={opt.id}>
                        { opt.clave ? `${ opt.nombre } - [${ opt.clave }]` : opt.nombre }
                    </option>)
                }
            </select>
        </div>
    )
}

Select.propTypes = {
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChangeFcn: PropTypes.func,
    visible: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    data: PropTypes.object
};
